function getNumber(value, fallback) {
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : fallback;
}

function initImagesMarquee(marquee) {
	if (marquee.dataset.imagesMarqueeInit === "true") {
		return;
	}

	const imageCount = getNumber(marquee.dataset.imageCount, 0);
	if (!imageCount) {
		return;
	}

	marquee.dataset.imagesMarqueeInit = "true";

	const speedOnMobile = getNumber(marquee.dataset.speedOnMobile, 20);
	const speedOnDesktop = getNumber(marquee.dataset.speedOnDesktop, 30);
	const pauseOnHover = marquee.dataset.pauseOnHover === "true";
	const firstSetImages = Array.from(marquee.querySelectorAll("img")).slice(
		0,
		imageCount,
	);

	const updateMarquee = () => {
		const items = Array.from(marquee.children).slice(0, imageCount);
		const styles = getComputedStyle(marquee);
		const gap = parseFloat(styles.columnGap || styles.gap) || 0;
		const totalWidth = items.reduce((sum, el, index) => {
			return sum + el.offsetWidth + (index < items.length - 1 ? gap : 0);
		}, 0);

		if (totalWidth > 0) {
			marquee.style.setProperty("--marquee-distance", `-${totalWidth}px`);
		}

		const speed = window.innerWidth < 968 ? speedOnMobile : speedOnDesktop;
		marquee.style.animation = `marquee ${speed}s linear infinite`;
	};

	updateMarquee();

	firstSetImages.forEach((img) => {
		img.addEventListener("load", updateMarquee, { once: true });
		img.addEventListener("error", updateMarquee, { once: true });
	});

	let resizeFrame;
	window.addEventListener("resize", () => {
		cancelAnimationFrame(resizeFrame);
		resizeFrame = requestAnimationFrame(updateMarquee);
	});

	if (pauseOnHover) {
		marquee.addEventListener("mouseenter", () => {
			marquee.style.animationPlayState = "paused";
		});
		marquee.addEventListener("mouseleave", () => {
			marquee.style.animationPlayState = "running";
		});
		marquee.addEventListener("touchstart", () => {
			marquee.style.animationPlayState = "paused";
		});
		marquee.addEventListener("touchend", () => {
			marquee.style.animationPlayState = "running";
		});
	}
}

function bootImagesMarquees() {
	document
		.querySelectorAll("[data-images-marquee]")
		.forEach((marquee) => initImagesMarquee(marquee));
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", bootImagesMarquees);
} else {
	bootImagesMarquees();
}
